import { render, staticRenderFns } from "./system-msg.vue?vue&type=template&id=b3b4b9da"
import script from "./system-msg.vue?vue&type=script&lang=js"
export * from "./system-msg.vue?vue&type=script&lang=js"
import style0 from "./system-msg.vue?vue&type=style&index=0&id=b3b4b9da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports